
import { AuthError, AuthApiError } from "@supabase/supabase-js";

export const getAuthErrorMessage = (error: AuthError): string => {
  if (error instanceof AuthApiError) {
    switch (error.status) {
      case 400:
        if (error.message.includes("credentials")) {
          return "Invalid email or password. Please check your credentials and try again.";
        }
        break;
      case 401:
        return "Invalid email or password. Please check your credentials and try again.";
      case 403:
        return "Access denied. You don't have permission to access this resource.";
      case 404:
        return "The requested resource was not found.";
      case 422:
        if (error.message.includes("already been used")) {
          return "This email has already been used. Please try signing in instead.";
        }
        return "The provided credentials are invalid. Please check and try again.";
      case 429:
        return "Too many login attempts. Please try again later.";
    }

    // Check for common error messages
    if (error.message.includes("invalid_credentials")) {
      return "Invalid email or password. Please check your credentials and try again.";
    } else if (error.message.includes("email not confirmed")) {
      return "Please verify your email address before signing in.";
    } else if (error.message.includes("user not found")) {
      return "No user found with these credentials. Please check your email or sign up.";
    } else if (error.message.includes("Invalid login credentials")) {
      return "Invalid email or password. Please check your credentials and try again.";
    }
  }
  
  // Generic fallback
  return error.message || "An error occurred during login. Please try again.";
};
